import React from 'react'

export const author = ({store}) => <>{store.selected?.author && <span>von {store.selected?.author?.name}</span>}</>
export const genre  = ({store}) => <>{store.selected?.genre  && <span style={{opacity: .5}}>{store.selected?.genre?.name}</span>}</>
